import arrowIcon from '@/assets/img/newIndex/arrow.png';
import iconDailyScene from '@/assets/img/newIndex/每日一景.png';
import iconPhotoPicks from '@/assets/img/newIndex/摄影精选.png';
import iconOnlineConsult from '@/assets/img/newIndex/在线咨询.png';
import iconResidenceRegister from '@/assets/img/newIndex/居住登记.png';
import iconOnlineView from '@/assets/img/newIndex/在线查看.png';
import iconProgressQuery from '@/assets/img/newIndex/进展查询.png';
import iconStudentPermit from '@/assets/img/newIndex/学生许可.png';
import iconExtendPermit from '@/assets/img/newIndex/扩展许可.png';
import iconPassportChange from '@/assets/img/newIndex/护照更改.png';
import iconAddressChange from '@/assets/img/newIndex/地址变更.png';

export const newIndexArrowIcon = arrowIcon;

export const newIndexTeaserIcons = {
  daily: iconDailyScene,
  weekly: iconPhotoPicks
};

export const newIndexServiceIcons = {
  'srv-1': iconOnlineConsult,
  'srv-2': iconResidenceRegister,
  'srv-3': iconOnlineView,
  'srv-4': iconProgressQuery,
  'srv-5': iconStudentPermit,
  'srv-6': iconExtendPermit,
  'srv-7': iconPassportChange,
  'srv-8': iconAddressChange
};

export function getServiceIcon(id) {
  return newIndexServiceIcons[id] || newIndexServiceIcons['srv-1'];
}
